import styled from 'styled-components'
import { colors } from '../../styles/vars/colors.style'
import { mq } from '../../styles/vars/media-queries.style'
import { ContainerMain } from '../Container/index.style'
import { GridMain } from '../Grid/index.style'
import { GridItemMain } from '../GridItem/index.style'
// import backgroundImage from './images/WayToBook@2x-compress.jpg'

export const WayToBookMain = styled.div`
  overflow: hidden;
  background-color: ${colors.darkBlue};

  background-image: url('${props => props.bg}');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;

  ${ContainerMain},
  ${GridItemMain} {
    display: flex;
    width: 100%;
  }

  ${GridMain} {
    width: 100%;
  }

  ${mq.desk} {
    display: flex;
    flex-direction: column;
  }
`

export const WayToBookIntro = styled.div`
  color: ${colors.light};
  text-align: center;
  width: 100%;

  ${mq.desk} {
    margin-left: auto;
    margin-right: auto;
    max-width: 60em;
    width: 80%;
  }
`

export const WayToBookNav = styled.nav`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${mq.desk} {
    max-width: 140rem;
    margin: auto;
  }
`

export const WayToBookNavList = styled.div`
  width: 100%;
  position: relative;
  list-style: none;

  ${mq.desk} {
    flex-direction: row;

    .slider {
      display: flex;
      width: 100%;
    }
  }

  .slick-slider {
    width: 100%;
  }

  .slick-list {
    overflow: visible;
  }

  .slick-slider,
  .slick-list,
  .slick-track,
  .slick-slide > div {
    height: 100%;
  }
`
